var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowTick20Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 10C18.5 11.1875 17.75 12.1875 16.6875 12.5938C17.1562 13.5938 16.9688 14.8438 16.1562 15.6562C15.3125 16.5 14.0938 16.6875 13.0625 16.2188C12.6562 17.2812 11.6562 18 10.5 18C9.3125 18 8.3125 17.2812 7.90625 16.2188C6.90625 16.6875 5.65625 16.5 4.84375 15.6562C4 14.8438 3.8125 13.5938 4.28125 12.5938C3.21875 12.1875 2.5 11.1875 2.5 10C2.5 8.84375 3.21875 7.84375 4.28125 7.4375C3.8125 6.4375 4 5.1875 4.84375 4.34375C5.65625 3.53125 6.90625 3.34375 7.90625 3.8125C8.3125 2.75 9.3125 2 10.5 2C11.6562 2 12.6562 2.75 13.0625 3.8125C14.0625 3.34375 15.3125 3.53125 16.1562 4.34375C16.9688 5.1875 17.1562 6.4375 16.6875 7.4375C17.75 7.84375 18.5 8.84375 18.5 10ZM13.9688 8.625C14.0938 8.5 14.0938 8.28125 13.9688 8.15625L13.1562 7.34375C13.0312 7.1875 12.8125 7.1875 12.6562 7.34375L9.625 10.3438L8.3125 9.03125C8.1875 8.875 7.96875 8.875 7.8125 9L7 9.8125C6.875 9.96875 6.875 10.1875 7 10.3125L9.375 12.6875C9.5 12.8125 9.71875 12.8438 9.875 12.6875L13.9688 8.625Z",
    fill: "url(#paint0_linear_918_29219)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_918_29219",
    x1: 3.59474,
    y1: 1.15789,
    x2: 20.5772,
    y2: 15.6608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEDAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowTick20Px);
export default __webpack_public_path__ + "static/media/yellow-tick_20px.2baaf11f5b9268b0ab6dad9f1d922da7.svg";
export { ForwardRef as ReactComponent };